// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Core from "@material-ui/core";
import * as App_Styles$DvmAdminFrontendFr from "../../../common/App_Styles.bs.js";
import * as Order_Detail_Styles$DvmAdminFrontendFr from "./Order_Detail_Styles.bs.js";

function Order_Detail_Page_AppBar(Props) {
  var children = Props.children;
  return React.createElement(Core.AppBar, {
              children: React.createElement(Core.Grid, {
                    children: children,
                    className: Order_Detail_Styles$DvmAdminFrontendFr.titleBox,
                    container: true,
                    justifyContent: "space-evenly",
                    spacing: 1
                  }),
              className: App_Styles$DvmAdminFrontendFr.stickyBar
            });
}

var make = Order_Detail_Page_AppBar;

export {
  make ,
}
/* react Not a pure module */
